import {Component} from '@angular/core';

@Component({
  selector: 'app-debug-sentry',
  standalone: true,
  imports: [],
  templateUrl: './debug-sentry.component.html',
  styleUrl: './debug-sentry.component.css'
})
export class DebugSentryComponent{
  public throwTestError(): void {
    throw new Error("Sentry Test Error");
  }
}
